"use strict";
/*
* Created on 11.04.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var utils_1 = require("../../core/utils");

var SupplierOrderSuggested_1 = require("../model/SupplierOrderSuggested");

var SupplierOrderSuggestedConverter_1 = require("./SupplierOrderSuggestedConverter");
/**
 * Implementation of {@link SupplierOrderSuggestedConverter}.
 * @author ZSr
 */


var SupplierOrderSuggestedConverterImpl =
/*#__PURE__*/
function (_SupplierOrderSuggest) {
  _inherits(SupplierOrderSuggestedConverterImpl, _SupplierOrderSuggest);

  function SupplierOrderSuggestedConverterImpl() {
    _classCallCheck(this, SupplierOrderSuggestedConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierOrderSuggestedConverterImpl).apply(this, arguments));
  }

  _createClass(SupplierOrderSuggestedConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SupplierOrderSuggested_1.SupplierOrderSuggested(SupplierOrderSuggested_1.SupplierOrderSuggested.schema.id.valueOf(conversions.documentToClassId(source)), SupplierOrderSuggested_1.SupplierOrderSuggested.schema.externalId.valueOfField(source), SupplierOrderSuggested_1.SupplierOrderSuggested.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), SupplierOrderSuggested_1.SupplierOrderSuggested.schema.supplierId.valueOf(conversions.toClassReferenceId(source.supplierId)), SupplierOrderSuggested_1.SupplierOrderSuggested.schema.dateOfOrder.valueOfField(source), SupplierOrderSuggested_1.SupplierOrderSuggested.schema.promotionId.valueOf(utils_1.Utils.isValueMissing(source.promotionId) ? null : conversions.toClassReferenceId(source.promotionId)), SupplierOrderSuggested_1.SupplierOrderSuggested.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), SupplierOrderSuggested_1.SupplierOrderSuggested.schema.amount.valueOf(conversions.toBigNumber(source.amount)), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        siteId: conversions.toDocumentReferenceId(source.siteId),
        supplierId: conversions.toDocumentReferenceId(source.supplierId),
        dateOfOrder: conversions.fromDate(source.dateOfOrder),
        promotionId: utils_1.Utils.isValueMissing(source.promotionId) ? null : conversions.toDocumentReferenceId(source.promotionId),
        productId: conversions.toDocumentReferenceId(source.productId),
        amount: conversions.fromBigNumber(source.amount),
        stateFlags: source.stateFlags.serialize()
      });
      return result;
    }
  }]);

  return SupplierOrderSuggestedConverterImpl;
}(SupplierOrderSuggestedConverter_1.SupplierOrderSuggestedConverter);

exports.SupplierOrderSuggestedConverterImpl = SupplierOrderSuggestedConverterImpl;